import * as Sentry from "@sentry/browser";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "src/Redux";
import { ThemeProvider } from "styled-components";

import { GlobalStyles } from "@components";
import { enumTheme } from "@configs";
import { ModuleMain } from "@modules";
import CacheStore from "@Rocket-Innovation/components/store/CacheStore";
import "@translations/i18n";
import { dark, light, theme } from "@utils";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import checkBlockMerchant from "./Utils/checkBlockMerchant";
import getMerchant from "./Utils/getMerchant";

declare global {
    interface Window {
        overrideUserInterfaceStyle: string;
    }
}

window.overrideUserInterfaceStyle = window.overrideUserInterfaceStyle || "";
const isTechDomain = () => {
    const currentURL = window.location.href;
    return currentURL.includes(".app");
};

Sentry.init({
    dsn: "https://6462a315e56003539598a3441f5632e8@o4506426275790848.ingest.us.sentry.io/4507140925882368",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    environment: isTechDomain() ? "production" : "development",
    // Performance Monitoring
    // tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// liff.use(new LIFFInspectorPlugin({ origin: "wss://liffdebugger.loca.lt" }));

function App() {
    const history = useHistory();
    const [themeMode, setThemeMode] = useState<enumTheme>(enumTheme.DARK);
    const [applyTheme, setApplyTheme] = useState<any>({ ...theme });
    useEffect(() => {
        document.documentElement.setAttribute("data-theme", themeMode);
        document.documentElement.setAttribute("style", `color-scheme: ${themeMode}`);
    }, [themeMode]);

    useEffect(() => {
        //FOR Blocking
        if (checkBlockMerchant()) return;
        callMerchantPrefix();
    }, []);
    const callMerchantPrefix = async () => {
        try {
            if ("overrideUserInterfaceStyle" in window) {
                window.overrideUserInterfaceStyle = "light";
            }
            const merchant = await getMerchant();
            if (merchant?.themes?.themeMode === "light") {
                setThemeMode(enumTheme.LIGHT);
                setApplyTheme({ ...theme, ...light });
            } else {
                setThemeMode(enumTheme.DARK);
                setApplyTheme({ ...theme, ...dark });
            }
        } catch {
            history?.push("/");
        }

        CacheStore.setState({ isMerchantReady: true });
    };

    return (
        <Provider store={store}>
            <ThemeProvider theme={applyTheme}>
                <GlobalStyles />
                <PersistGate loading={null} persistor={persistor}>
                    <ModuleMain />
                </PersistGate>
            </ThemeProvider>
        </Provider>
    );
}

export default App;
